import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/total-calls.svg'
import _imports_1 from '@/assets/images/answered-calls.svg'
import _imports_2 from '@/assets/images/missed-calls.svg'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "nav-total-calls",
  role: "tabpanel",
  "aria-labelledby": "nav-total-calls-tab",
  tabindex: "0"
}
const _hoisted_5 = { style: {"margin":"-24px -10px -26px -18px"} }
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "nav-answered-calls",
  role: "tabpanel",
  "aria-labelledby": "nav-answered-calls-tab",
  tabindex: "0"
}
const _hoisted_7 = { style: {"margin":"-24px -10px -26px -18px"} }
const _hoisted_8 = {
  class: "tab-pane fade",
  id: "nav-missed-calls",
  role: "tabpanel",
  "aria-labelledby": "nav-missed-calls-tab",
  tabindex: "0"
}
const _hoisted_9 = { style: {"margin":"-24px -10px -26px -18px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalCallsChart = _resolveComponent("TotalCallsChart")!
  const _component_AnsweredCallsChart = _resolveComponent("AnsweredCallsChart")!
  const _component_MissedCallsChart = _resolveComponent("MissedCallsChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 pb-4" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Overview"),
        _createElementVNode("div", { class: "dropdown select-dropdown" }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"35px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " This Year "),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " This Year ")
            ])
          ])
        ])
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        id: "nav-tab",
        class: "call-overview-tabs",
        role: "tablist"
      }, [
        _createElementVNode("div", { class: "row justify-content-center" }, [
          _createElementVNode("div", { class: "col-md-4 col-sm-6" }, [
            _createElementVNode("div", {
              class: "card bg-primary bg-opacity-10 border-0 rounded-3 p-4 mb-4 calls-card active",
              id: "nav-total-calls-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nav-total-calls",
              type: "button",
              role: "tab",
              "aria-controls": "nav-total-calls",
              "aria-selected": "true"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                _createElementVNode("div", { class: "flex-grow-1 me-3" }, [
                  _createElementVNode("span", { class: "text-body d-block mb-1" }, "Total Calls"),
                  _createElementVNode("h3", { class: "fs-24 fw-semibold text-secondary" }, "26,435")
                ]),
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "total-calls"
                  })
                ])
              ]),
              _createElementVNode("span", { class: "d-flex align-items-center align-items-center text-body" }, [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 pe-2 position-relative top-1 text-success" }, " trending_up "),
                _createElementVNode("span", { class: "fw-medium me-1 text-secondary" }, "+15%"),
                _createTextVNode(" last year ")
              ])
            ])
          ]),
          _createElementVNode("div", { class: "col-md-4 col-sm-6" }, [
            _createElementVNode("div", {
              class: "card bg-primary-divs border-0 rounded-3 p-4 mb-4 calls-card",
              id: "nav-answered-calls-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nav-answered-calls",
              type: "button",
              role: "tab",
              "aria-controls": "nav-answered-calls",
              "aria-selected": "false",
              style: {"background-color":"#faf5ff"}
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                _createElementVNode("div", { class: "flex-grow-1 me-3" }, [
                  _createElementVNode("span", { class: "text-body d-block mb-1" }, "Answered Calls"),
                  _createElementVNode("h3", { class: "fs-24 fw-semibold text-secondary" }, "18,520")
                ]),
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "answered-calls"
                  })
                ])
              ]),
              _createElementVNode("span", { class: "d-flex align-items-center align-items-center text-body" }, [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 pe-2 position-relative top-1 text-success-60" }, " trending_up "),
                _createElementVNode("span", { class: "fw-medium me-1 text-secondary" }, "+15%"),
                _createTextVNode(" last year ")
              ])
            ])
          ]),
          _createElementVNode("div", { class: "col-md-4 col-sm-12" }, [
            _createElementVNode("div", {
              class: "card bg-dangers border-0 rounded-3 p-4 mb-4 calls-card",
              id: "nav-missed-calls-tab",
              "data-bs-toggle": "tab",
              "data-bs-target": "#nav-missed-calls",
              type: "button",
              role: "tab",
              "aria-controls": "nav-missed-calls",
              "aria-selected": "false",
              style: {"background-color":"#fff5ed"}
            }, [
              _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                _createElementVNode("div", { class: "flex-grow-1 me-3" }, [
                  _createElementVNode("span", { class: "text-body d-block mb-1" }, "Missed Calls"),
                  _createElementVNode("h3", { class: "fs-24 fw-semibold text-secondary" }, "3,735")
                ]),
                _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "missed-calls"
                  })
                ])
              ]),
              _createElementVNode("span", { class: "d-flex align-items-center align-items-center text-body" }, [
                _createElementVNode("i", { class: "material-symbols-outlined fs-18 pe-2 position-relative top-1 text-danger-50" }, " trending_down "),
                _createElementVNode("span", { class: "fw-medium me-1 text-secondary" }, "-25%"),
                _createTextVNode(" last year ")
              ])
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TotalCallsChart)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AnsweredCallsChart)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_MissedCallsChart)
          ])
        ])
      ])
    ])
  ]))
}